import i18n from './i18n';

// Get the current locale for formatting (maps i18n language to locale)
function getLocale() {
  const lang = i18n.language || 'en';
  // Map language codes to full locales
  const localeMap = {
    'en': 'en-US',
    'de': 'de-DE',
  };
  return localeMap[lang] || 'en-US';
}

export function numberWithCommas(x) {
  if (x === 0) {
    return "0"
  }
  if (Math.abs(x) < 10 && !Number.isInteger(x)) {
    return new Intl.NumberFormat(getLocale(), {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }).format(x);
  }
  return new Intl.NumberFormat(getLocale(), {
    maximumFractionDigits: 0
  }).format(Math.round(x));
}

export function shortNumber(x) {
  return numberWithCommas(x/1000000) + "M"
}

export function renderShortDate(timestamp) {
  if (!timestamp) {
    return 'Unknown'
  }
  return new Date(timestamp).toLocaleDateString(getLocale())
}

export function renderDate(timestamp) {
  return new Date(timestamp).toLocaleString(getLocale());
}

export function subtractMaterials(inventory, materials) {
  inventory = Object.assign({}, inventory);
  Object.keys(materials).forEach(name => {
    if (!(name in inventory)) {
      inventory[name] = 0
    }
    inventory[name] -= materials[name]
  });
  return inventory
}

export function divideMaterials(inventory, materials) {
  inventory = Object.assign({}, inventory);
  let factor = null;
  Object.keys(materials).forEach(name => {
    if (!(name in inventory)) {
      return 0
    }
    let thisFactor = inventory[name] / materials[name];
    if (factor === null || thisFactor < factor) {
      factor = thisFactor;
    }
    inventory[name] -= materials[name]
  });
  return factor || 0;
}

export function inventoryFromMaterialsMap(materialsMap, location) {
  let inventory = {};
  Object.keys(materialsMap).forEach(name => {
    let material = materialsMap[name];
    if (location === "") {
      inventory[name] = material.totalInventory;
    } else {
      inventory[name] = material.inventory[location] || 0;
    }
  });
  return inventory;
}

export function stripCorpTag(name) {
  if (!name) {
    return;
  }
  return name.replace('[PAND]', '').replace('[VIRI]', '').trim();
}

export function parseNumber(numberStr) {
  // Handle both English (1,000.50) and German (1.000,50) number formats
  // Detect format: if string has comma after dot, it's German format
  const hasGermanFormat = /\d\.\d{3}/.test(numberStr) || /,\d{1,2}$/.test(numberStr);

  if (hasGermanFormat) {
    // German: dots are thousands separators, comma is decimal
    numberStr = numberStr.replace(/\./g, '').replace(/,/g, '.');
  } else {
    // English: commas are thousands separators, dot is decimal
    numberStr = numberStr.replace(/,/g, '');
  }

  numberStr = numberStr.replace(/\$/g, '').toLowerCase();
  let multiplier = 1;
  let suffix = numberStr.slice(-1);
  if (suffix === 'k') {
    multiplier = 1000;
    numberStr = numberStr.slice(0, -1);
  }
  if (suffix === 'm') {
    multiplier = 1000000;
    numberStr = numberStr.slice(0, -1);
  }
  if (suffix === 'b') {
    multiplier = 1000000000;
    numberStr = numberStr.slice(0, -1);
  }
  return Number(numberStr) * multiplier;
}

export function toTitleCase(str) {
  return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
  );
}

export function getQueryVariable(input, variable) {
  var query = input.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log('Query variable %s not found', variable);
}